module.exports = __webpack_public_path__ + "img/8.95074353.gif";